export default "__VITE_ASSET__uPN9g3yh__"